import { render, staticRenderFns } from "./CatalogTime.vue?vue&type=template&id=5f285a99"
import script from "./CatalogTime.vue?vue&type=script&lang=js"
export * from "./CatalogTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports